module.exports = __webpack_public_path__ + "img/SDB.99d35dac.jpg";